export interface DownloadCountDetail {
  value: string;
  unit: string;
  isZero: boolean;
}

export function formatDownloadCountDetail(n: number): DownloadCountDetail {
  return {
    value: formatCatalogCount(n),
    unit: n === 1 ? "DOWNLOAD" : "DOWNLOADS",
    isZero: n === 0,
  };
}

export function formatDownloadCountRow(n: number): string {
  return formatCatalogCount(n);
}

export function downloadCountAriaLabel(n: number): string {
  return `${formatCatalogCount(n)} ${n === 1 ? "download" : "downloads"}`;
}

export function formatCatalogCount(n: number): string {
  return n.toLocaleString("en-US");
}

export const DOWNLOAD_COUNT_DISPLAY_FLOOR = 25;

export function visibleDownloadCount(n: number): DownloadCountDetail | null {
  return n === 0 || n >= DOWNLOAD_COUNT_DISPLAY_FLOOR ? formatDownloadCountDetail(n) : null;
}

export function formatHubCounts(sounds: number, downloads: number, { floor = false } = {}): string {
  const soundPart = `${formatCatalogCount(sounds)}${floor ? "+" : ""} ${sounds === 1 && !floor ? "sound" : "sounds"}`;
  if (floor || downloads === 0) return soundPart;
  return `${soundPart}, ${downloadCountAriaLabel(downloads)}`;
}
